import React from 'react';
import './AssetManagement.css';
import Checkout from '../components/Checkout';

const AssetManagement = () => {
  return (
    <>
    <div className="asset-management">
      Asset Management content coming soon
    </div>
    <Checkout />
    </>
  );
};

export default AssetManagement;
